export const updateDepositUrl = (url) => {
  const newUrl = new URL(url);

  if (typeof window !== 'undefined') {
    const userAgent = window.navigator.userAgent;
    const isIOSWrapperPresent =
      userAgent.includes('5eaaadc3-3145-4490-a4d8-db9bdf9d4182') ||
      userAgent.includes('c99a9785-8a16-4801-9474-02b5a8fbb58e');

    if (isIOSWrapperPresent) {
      newUrl.searchParams.set('hide_header', 2);
    } else {
      newUrl.searchParams.set('merchantDomain', window.location.hostname);
    }
  }
  return newUrl.toString();
};
